const defaultSetup = {
  options: {
    productCode: "datacore",
  },
  copyright: "Synergy Sports",
  languages: ["en-AU", "en-GB"],
  // languages: ["en-AU", "en-GB", "es-ES", "fr-FR", "de-DE"]
};
export default defaultSetup;
